(function () {
  const STORAGE_KEY = "dritya_wishlist";

  function readWishlist() {
    try {
      const data = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(
      new CustomEvent("wishlist:updated", {
        detail: {
          items,
          count: items.length
        }
      })
    );
  }

  function getWishlist() {
    return readWishlist();
  }

  function isWishlisted(handle) {
    return readWishlist().includes(handle);
  }

  function addToWishlist(handle) {
    if (!handle) return;
    const items = readWishlist();
    if (!items.includes(handle)) {
      items.push(handle);
      saveWishlist(items);
    }
  }

  function removeFromWishlist(handle) {
    if (!handle) return;
    const items = readWishlist().filter((item) => item !== handle);
    saveWishlist(items);
  }

  function toggleWishlist(handle) {
    if (!handle) return false;

    const active = isWishlisted(handle);
    if (active) {
      removeFromWishlist(handle);
      return false;
    } else {
      addToWishlist(handle);
      return true;
    }
  }

  function updateButtonState(button) {
    const handle = button.dataset.productHandle;
    if (!handle) return;

    const active = isWishlisted(handle);

    button.classList.toggle("is-active", active);
    button.setAttribute("aria-pressed", active ? "true" : "false");
    button.setAttribute(
      "aria-label",
      active ? "Remove from wishlist" : "Add to wishlist"
    );

    const textTarget = button.querySelector("[data-wishlist-text]");
    if (textTarget) {
      textTarget.textContent = active ? "Wishlisted" : "Wishlist";
    }
  }

  function updateAllButtons(scope) {
    const root = scope || document;
    root.querySelectorAll("[data-wishlist-toggle]").forEach(updateButtonState);
  }

  function updateCountBadges() {
    const count = getWishlist().length;
    document.querySelectorAll("[data-wishlist-count]").forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? "inline-flex" : "none";
    });
  }

  function refreshWishlistUI(scope) {
    updateAllButtons(scope || document);
    updateCountBadges();
  }

  // Initial load
  document.addEventListener("DOMContentLoaded", function () {
    refreshWishlistUI(document);
  });

  // Shopify section re-render
  document.addEventListener("shopify:section:load", function (event) {
    refreshWishlistUI(event.target);
  });

  // Repaint all buttons when wishlist changes
  document.addEventListener("wishlist:updated", function () {
    refreshWishlistUI(document);
  });

  // EVENT DELEGATION: works for infinite scroll / appended products too
  document.addEventListener("click", function (event) {
    const button = event.target.closest("[data-wishlist-toggle]");
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;
    if (!handle) return;

    toggleWishlist(handle);
    refreshWishlistUI(document);
  });

  // Optional: observe DOM changes from infinite scroll and sync new buttons
  const observer = new MutationObserver(function (mutations) {
    let shouldRefresh = false;

    for (const mutation of mutations) {
      if (mutation.addedNodes && mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          if (
            node.matches?.("[data-wishlist-toggle]") ||
            node.querySelector?.("[data-wishlist-toggle]")
          ) {
            shouldRefresh = true;
            break;
          }
        }
      }

      if (shouldRefresh) break;
    }

    if (shouldRefresh) {
      refreshWishlistUI(document);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.DrityaWishlist = {
    getWishlist,
    isWishlisted,
    addToWishlist,
    removeFromWishlist,
    toggleWishlist,
    refreshWishlistUI
  };
})();